import { type FC } from 'react';
import { Stack, Typography } from '@mui/material';

import { type AuditLightingTypeFormEntry } from '#packages/data-collection/models/audit-lighting-type-form';
import {
  ColorTemperatureLabel,
  FixtureTypeLabel,
  LampTypeLabel,
} from '#apps/client-web/features/audit-form-lighting-type/constants';

export const LightingTypeEntryDetails: FC<{
  entry: AuditLightingTypeFormEntry;
}> = ({ entry }) => (
  <Stack spacing={0.25}>
    <Stack direction="row" spacing={0.5} flexWrap="wrap">
      <Typography component="span" variant="body2" fontWeight="bold">
        {entry.fixtureType ? FixtureTypeLabel[entry.fixtureType] : '—'}
      </Typography>
      <Typography component="span" variant="body2" color="textSecondary">
        •
      </Typography>
      <Typography component="span" variant="body2">
        {entry.lampType ? LampTypeLabel[entry.lampType] : '—'}
      </Typography>
    </Stack>
    <Stack direction="row" spacing={1} flexWrap="wrap">
      {entry.quantity != null && (
        <Typography variant="caption" color="textSecondary">
          {entry.quantity} lamps
        </Typography>
      )}
      {entry.lampWattage != null && (
        <Typography variant="caption" color="textSecondary">
          {entry.lampWattage} W
        </Typography>
      )}
      {entry.colorTemperature && (
        <Typography variant="caption" color="textSecondary">
          {ColorTemperatureLabel[entry.colorTemperature]}
        </Typography>
      )}
    </Stack>
  </Stack>
);
